import { INVALIDATE_FISCALITE } from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';
import {
  GET_OBLIGATIONS_FISCALES_API_ROUTE,
  PARAMETRES_FISCAUX_API_ROUTE,
} from 'routes/api/endpoints';

const fiscaliteApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getObligationsFiscales: build.query({
      query: ({ dossier_id }) =>
        `${GET_OBLIGATIONS_FISCALES_API_ROUTE}?dossier_id=${dossier_id}`,
      providesTags: [INVALIDATE_FISCALITE],
    }),
    getParametresFiscaux: build.query({
      query: ({ dossier_id }) =>
        `${PARAMETRES_FISCAUX_API_ROUTE}?dossier_id=${dossier_id}`,
      providesTags: [INVALIDATE_FISCALITE],
    }),
  }),
});

export const { useGetObligationsFiscalesQuery, useGetParametresFiscauxQuery } =
  fiscaliteApi;
